import React, { useEffect } from "react";
import { Link, NavLink }             from "react-router-dom";
import { AxiosResponse }    from "axios";
/* Project References */
import Pagination             from "../../../components/Pagination";
import { Event }              from "../../../models/Event";
import SkeletonTableLoad      from "../../../components/SkeletonTableLoad";
import { PageableCollection } from "../../../models/PageableCollection";

import msalRestClient from "../../../services/clients/MsalRestClient";

const Events = () => {

    // #region Init States

    // Initial model that represents an empty event collection
    let emptyCollection: PageableCollection<Event> = {
        totalPages : 0,
        count      : 0,
        next       : "",
        previous   : "",
        results    : []
    }

    // #endregion

    // #region States & Hooks

    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [events, setEvents]       = React.useState<PageableCollection<Event>>(emptyCollection);

    useEffect(() => { fetchFromApi(1); }, []);

    // #endregion

    /**
     * ...
     * @param page
     */
    const fetchFromApi = (page?: number) => {

        setIsLoading(true);
        let endpoint = "/api/events" + (page ? "?page=" + page : "");

        msalRestClient.get<PageableCollection<Event>>(endpoint)
            .then(response => onApiSuccess(response))
            .catch(error   => console.error("API Exception: " + error))
            .finally(()    => setIsLoading(false));
    }

    /**
     * ...
     * @param response
     */
    const onApiSuccess = (response: AxiosResponse<PageableCollection<Event>, any>) => {

        if (response.status === 200) {
            setEvents(response.data);
        }
        else if (response.status === 204) {
            setEvents(emptyCollection);
        }
    }

    // JSX Element for rendering in browser
    return (
        <main className="container">

            <div className="row">

                <div className="col-12 col-md-6 mb-2">
                    <NavLink to="/admin/events/create" className="btn btn-success">
                        <i className="bi bi-plus-lg me-1" />New Seminar
                    </NavLink>
                </div>

                <div className="col-12 col-md-6">
                    <Pagination onPageChange={fetchFromApi} next={events.next} previous={events.previous} count={events.count} totalPages={events.totalPages} />
                </div>

                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            {
                                isLoading ? <SkeletonTableLoad columnCount={5} rowCount={15} striped={false} />
                                    :
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Number</th>
                                                <th>Title</th>
                                                <th>Startdate</th>
                                                <th>Enddate</th>
                                                <th>Location</th>
                                                <th>
                                                    { /* Empty for edit controls */ }
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                events.results.map((value, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{value.id}</td>
                                                            <td>{value.number}</td>
                                                            <td>{value.title}</td>
                                                            <td>{new Date(value.startDate).toLocaleDateString()}</td>
                                                            <td>{new Date(value.endDate).toLocaleDateString()}</td>
                                                            <td>{value.location}</td>
                                                            <td>
                                                                <Link to={"/admin/event/" + value.id} className="btn btn-warning">
                                                                    <i className="bi bi-pencil"></i>
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                            }
                        </div>
                    </div>
                </div>

            </div>

        </main>
    )
}
export default Events;